var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningDpJob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79644 0.0271842C9.48504 -0.592395 8.51664 -0.592395 8.20524 0.0271842L0.105242 16.1324C0.0323269 16.2768 -0.00382116 16.4386 0.000319671 16.602C0.0044605 16.7654 0.0487489 16.9249 0.12887 17.065C0.208991 17.205 0.322211 17.3209 0.457499 17.4012C0.592788 17.4815 0.745529 17.5235 0.900842 17.5232H17.1008C17.256 17.5235 17.4087 17.4815 17.5439 17.4013C17.6791 17.321 17.7922 17.2053 17.8723 17.0653C17.9523 16.9253 17.9965 16.7659 18.0006 16.6026C18.0047 16.4393 17.9685 16.2776 17.8955 16.1334L9.79644 0.0271842ZM9.90084 14.6811H8.10084V12.7863H9.90084V14.6811ZM8.10084 10.8916V6.15476H9.90084L9.90174 10.8916H8.10084Z",
    fill: "#FFA200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningDpJob);
export default __webpack_public_path__ + "static/media/warning-dp-job.7c8bbc3fd4f6515a8b7595dd221551ef.svg";
export { ForwardRef as ReactComponent };